<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="expirationstatusForm">
      <div class="">
        <h3 class="form_name">Expiration Status Form</h3>
  
        <div class="input">
          <label for="">Expiration Status Name</label>
          <input type="text" class="default_input reference-form" formControlName="ExpirationStatusName" />
        </div>
  
      
        
  
        <div class="btn_holder">
          <button class="default_primary-button" *ngIf="selectedIndex === null" (click)="addNew(expirationstatusForm.value)">Add</button>
          <button class="default_primary-button" *ngIf="selectedIndex !== null" (click)="addNew(expirationstatusForm.value)">Update</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for Expiration Status name"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(expirationstatuss | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectedExpirationStatus(option.id)"
                  *ngFor="let option of result"
                  [value]="option.ExpirationStatusName" 
                >
               
  
                  {{option.ExpirationStatusName}}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
         
          <span class="item">Expiration Status Name</span>
         
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let expirationstatus of expirationstatusFormArray.get('ExpirationStatuss')['controls']; index as i"
        (click)="onEdit(i, expirationstatus.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          
          <span class="content">{{expirationstatus.value.ExpirationStatusName}}</span>
        
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteExpirationStatus(i, expirationstatus.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(expirationstatusFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>